import { toast } from "react-toastify";
import api from "../../Service/api";

export const GetUserWalletApi = async (id) => {
  // Check for internet connection
  if (navigator.onLine === false) {
    toast.error("No Internet Connection, Try again");
  } else {
    try {
      const response = await api.get(`/wallet/user/${id}`);

      if (response.status === 200) {
        // Return the data to the Saga
        return response.data;
      } else {
        toast.error(response.data.message || "Failed to fetch wallet");
      }
    } catch (error) {
      // Handle error response
      const errorMessage = error.response?.data?.message || "An error occurred";
      toast.error(errorMessage);
      throw error;
    }
  }
};

export const CreateFundingIntentApi = async (payload) => {
  try {
    const response = await api.post(`/wallet-funding/funding-intent`, payload);
    if (response.data.status) return response.data;
    else throw new Error(response.data.message);
  } catch (error) {
    toast.error(
      error.response?.data?.message || "Failed to create funding intent",
    );
    throw error;
  }
};

export const InitializeFundingPaymentApi = async (payload) => {
  try {
    const response = await api.post(
      `/wallet-funding/initialize-payment`,
      payload,
    );
    const responseData = response.data;

    if (responseData.status) {
      // 👉 1. FIND THE REFERENCE (Handles OPay, Paystack, Flutterwave formats)
      const backendReference =
        responseData.data?.reference || // Paystack standard
        responseData.data?.orderNo || // OPay nested
        responseData.gateway_reference || // OPay root level
        responseData.reference; // Generic fallback

      // 👉 2. SAVE TO LOCAL STORAGE (Crucial for OPay!)
      if (backendReference) {
        localStorage.setItem("wallet_funding_ref", backendReference);
      }

      // 3. REDIRECT THE USER
      const redirectUrl =
        responseData.payment_url ||
        responseData.data?.authorization_url ||
        responseData.data?.link ||
        responseData.raw?.payment_url;

      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        toast.error("Payment initialized, but redirect URL is missing.");
      }
      return responseData;
    } else throw new Error(responseData.message);
  } catch (error) {
    console.error(error);
    toast.error(
      error.response?.data?.message || "Failed to initialize payment",
    );
    throw error;
  }
};

export const VerifyFundingPaymentApi = async (payload) => {
  try {
    const response = await api.post(`/wallet-funding/verify-payment`, payload);
    if (response.data.status) {
      toast.success(response.data.message);
      return response.data;
    } else throw new Error(response.data.message);
  } catch (error) {
    toast.error(error.response?.data?.message || "Verification Failed");
    throw error;
  }
};
export const GetWalletHistoryApi = async (params) => {
  try {
    // Axios allows passing query parameters via the 'params' object
    const response = await api.get(`/wallet/wallet-history`, { params });
    return response.data; // Ensure this returns { data: [...], statistics: {...}, ... }
  } catch (error) {
    toast.error(
      error.response?.data?.message || "Failed to fetch wallet history",
    );
    throw error;
  }
};

export const GetAdminWalletHistoryApi = async (params) => {
  try {
    const response = await api.get(`/wallet/admin-wallet-history`, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const GetCustomerWalletsApi = async (params) => {
  try {
    const response = await api.get(`/wallet/customer-wallet`, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const ProcessWalletRefundApi = async (payload) => {
  try {
    const response = await api.post(`/wallet-funding/refund`, payload);

    // 👉 FIX: Check for 'success' or 'status', or rely on Axios's 200 HTTP status
    if (
      response.status === 200 &&
      (response.data.success || response.data.status)
    ) {
      // Use the backend's message if available
      toast.success(response.data.message || "Refund processed successfully!");
      return response.data;
    } else throw new Error(response.data.message || "Failed to process refund");
  } catch (error) {
    // Fallback to error message
    const errorMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to process refund";
    toast.error(errorMsg);
    throw error;
  }
};

export const ProcessWalletRewardApi = async (payload) => {
  try {
    const response = await api.post(`/wallet-funding/reward`, payload);

    // 👉 FIX: Check for 'success' or 'status'
    if (
      response.status === 200 &&
      (response.data.success || response.data.status)
    ) {
      toast.success(response.data.message || "Reward credited successfully!");
      return response.data;
    } else throw new Error(response.data.message || "Failed to process reward");
  } catch (error) {
    const errorMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to process reward";
    toast.error(errorMsg);
    throw error;
  }
};
